export const OpportunityEntity = {
    "_declaration": {
        "_attributes": { "version": "1.0", "encoding": "UTF-8" }
    },
    "content": {
        "name": "",
        "id": "",
        "client": {
            "name": "",
            "id": "",
        },
        "deadline": "",
        "creationDateTime": "",
        "manager": {
            "displayName": "",
            "email": "",
            "id": "",
        },
    }
}